import { Box } from "@mui/material";
import { Dimensions } from "constant";
import styled from "styled-components";
import { AnnotationTypes } from "constant";
import React, { useEffect, useState } from "react";
import BlackSelect from "components/common/BlackSelect";
import useProjectStore from '../../store-zustand/project';
import TooltipIconButton from "components/TooltipIconButton";
import { Content as Wrapper, FormItem } from '../ActionModal';
import { FlipToFront as FlipToFrontIcon } from "@mui/icons-material";

const InfoMain = styled.p`
  margin: 0;
  font-weight: 700;
  font-size: 15px;
  color: rgb(222, 222, 222);
  line-height: 1.5;
  font-family: Roboto;
`;

const InfoSecond = styled.p`
  margin: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.6em;
  color: rgb(202, 202, 202);
`;

const InfoLongLang = styled.p`
  font-size: 14px;
  margin: 10px -7px 15px -4px;
  line-height: 1.6em;
  color: ${({ theme }) => theme.textColor.secondary};
`;

const MeasurementValue = styled(Box)`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: rgb(222, 222, 222);
  font-family: Roboto;
  font-size: 15px;
  font-weight: 700;
`;

const textMeasurementStyle = {
  marginRight: '10px'
}

const lengthDimensions = [
  'm',
  'ft',
  'ml',
  'km',
  'yr']

const MapContent = (props) => {
  const { info, type, onChangeDimension } = props;
  const { project_modal_information } = useProjectStore();
  const [actualMeasurementvalue, setactualMeasurementvalue] = useState();
  const [measurementUnit, setmeasurementUnitDimension] = useState();
  const [actualMeasurementUnit, setactualMeasurementUnit] = useState('');
  const [DefaultMeasurementvalue, setDefaultMeasurementvalue] = useState();
  const [displayMeasurement, setdisplayMeasurement] = useState(true);

  useEffect(() => {
    if (info.hasOwnProperty('value')) {

      setdisplayMeasurement(true);
      if (info.value != 'none' & info.value != '') {
        let arrayMeasurement = info.value.split(" ");

        let defaultUnit = arrayMeasurement[1];
        let defaultUnitWithoutDimensions = arrayMeasurement[1].replace('²', '');
        setactualMeasurementvalue(parseFloat(arrayMeasurement[0]).toFixed(2));
        setDefaultMeasurementvalue(parseFloat(arrayMeasurement[0]).toFixed(2));
        if (defaultUnit.includes('²')) {
          setmeasurementUnitDimension('square');
        } else {
          setmeasurementUnitDimension('oneDimension');
        }
        setactualMeasurementUnit(defaultUnitWithoutDimensions);
      } else {
        setactualMeasurementUnit('');
        setactualMeasurementvalue('');
        setdisplayMeasurement(false);
      }
    }
  }, [info])

  function defineNewMeasurementValue(Factor, unit) {
    let value = 0;
    if (measurementUnit == 'oneDimension') {
      value = (parseFloat(DefaultMeasurementvalue) * Factor).toFixed(2);
    } else if (measurementUnit == 'square') {
      value = (parseFloat(DefaultMeasurementvalue) * Math.pow(Factor, 2)).toFixed(2);
    }
    setactualMeasurementvalue(value);
    setactualMeasurementUnit(unit);
  }

  const onChangeUnit = (event) => {
    let LineDimension = event;
    switch (LineDimension) {
      case 'ft':
        defineNewMeasurementValue(3.28084, event);
        break;
      case 'ml':
        defineNewMeasurementValue(0.000621371, event);
        break;
      case 'km':
        defineNewMeasurementValue(0.001, event);
        break;
      case 'yr':
        defineNewMeasurementValue(1.09361, event);
        break;
      case 'm':
        defineNewMeasurementValue(1, event);
        break;
      default:
        defineNewMeasurementValue(1, 'm');
    }
  };

  let address_project;
  let projectname;
  let address;
  let country;
  let region;
  let place;
  let postal_code;
  let location_string;
  if (project_modal_information) {
    address = project_modal_information.info.address;
    projectname = project_modal_information.info.projectname;

    if (address === null || address === `` || projectname === null || projectname === ``) {
      address_project = 'Untitled';
    } else if (address === projectname && address !== null) {
      address_project = address;
    } else {
      address_project = `${projectname}, ${address}`;
    }
    country = project_modal_information.info.country;
    region = project_modal_information.info.region;
    place = project_modal_information.info.place_name;
    postal_code = project_modal_information.info.postal_code;

    if (country !== '' && place !== '' && postal_code !== '') {
      location_string = `${country}, ${place}, ${postal_code}`;
    } else {
      location_string = region;
    }
  }

  const handleChangeDimension = (dimension) => {
    onChangeDimension(dimension);
    let arrayMeasurement = info.value.split(" ");
    setactualMeasurementvalue(parseFloat(arrayMeasurement[0]));
  }

  return (
    <Wrapper>
      {!AnnotationTypes[type] ?
        (<>
          <InfoMain>{address_project}</InfoMain>
          <InfoSecond>{location_string}</InfoSecond>
          <InfoSecond>{country}</InfoSecond>
        </>) 
        : 
        (<InfoMain>{info.annotationname} </InfoMain>)
      }
      <InfoLongLang>{info.annotationdescription != "" ? info.annotationdescription : info.description}</InfoLongLang>
      {AnnotationTypes[type] ? (
        <MeasurementValue>
          <span style={textMeasurementStyle}>{actualMeasurementvalue}</span>
          {measurementUnit == 'square' ? 
            ((displayMeasurement === true ? 
              (<FormItem><BlackSelect options={lengthDimensions.map((item) => ({ label: `${item}²`, value: item }))} value={actualMeasurementUnit} onChange={onChangeUnit} /></FormItem>) 
              : 
              (<></>))
            ) 
            : 
            ((displayMeasurement === true ? 
              (<FormItem><BlackSelect options={lengthDimensions.map((item) => ({ label: `${item}`, value: item }))} value={actualMeasurementUnit} onChange={onChangeUnit} /></FormItem>) 
              : 
              (<></>))
            )
          }
          <FormItem>
            <BlackSelect options={Dimensions.map((item) => ({ label: item, value: item }))} value={info.dimension} onChange={handleChangeDimension} />
          </FormItem>
          <TooltipIconButton title="Copy" ariaLabel="copy" placement="top" size={34}>
            <FlipToFrontIcon fontSize="large" />
          </TooltipIconButton>
        </MeasurementValue>
      ) : (
        <></>
      )}
    </Wrapper>
  );
};

export default MapContent;
